export class HideFilter {

	constructor(selector, options = {}) {

		this.parent = typeof selector === 'string'
			? document.querySelector(selector)
			: selector;

		if (!this.parent) return;

		const defaultOptions = {
			triggersClass: '.ToggleSectionTriggers',
			triggerClass: '.ToggleSectionTrigger',
			targetsClass: '.ToggleSectionTargets',
			targetClass: '.ToggleSectionTarget',
			dataAttr: 'data-toggle-section-id',
			hideOthers: false,
			activeClass: 'active',
			hideClass: 'hide'
		};

		this.options = Object.assign(defaultOptions, options);

		this.allTriggers = [];
		this.allTargets = [];
		this.activeIds = new Set();

		this._onClick = this._onClick.bind(this);

		this._setup();
	}

	_setup() {

		const triggers = this.parent.querySelectorAll(
			`${this.options.triggersClass} ${this.options.triggerClass}`
		);

		const targets = this.parent.querySelectorAll(
			`${this.options.targetsClass} ${this.options.targetClass}`
		);

		this.allTriggers = triggers;
		this.allTargets = targets;

		triggers.forEach(trigger => {
			trigger.addEventListener("click", this._onClick);
		});
	}

	_onClick(event) {
		
		const trigger = event.currentTarget;
		const triggerId = trigger.getAttribute(this.options.dataAttr);
	
		// If the clicked trigger has no/empty data-attr: reset all, make it active
		if (!triggerId) {
			this.reset();
			trigger.classList.add(this.options.activeClass);
			return;
		}
	
		// toggle selection state
		if (this.activeIds.has(triggerId)) {
			this.activeIds.delete(triggerId);
		} else {
			this.activeIds.add(triggerId);
		}
	
		if (this.options.hideOthers) {
			this._renderFilterMode();
		} else {
			this._renderToggleMode();
		}
	}

	// ----------------------------------------
	// MODE 1: FILTER MODE (hideOthers = true)
	// ----------------------------------------
	_renderFilterMode() {

		const hasActive = this.activeIds.size > 0;

		const apply = (items) => {
			items.forEach(item => {

				const id = item.getAttribute(this.options.dataAttr);

				const shouldShow =
					!hasActive || this.activeIds.has(id);

				item.classList.toggle(this.options.hideClass, !shouldShow);

				item.classList.toggle(
					this.options.activeClass,
					this.activeIds.has(id)
				);
			});
		};

		apply(this.allTriggers);
		apply(this.allTargets);
	}

	// ----------------------------------------
	// MODE 2: TOGGLE MODE (hideOthers = false)
	// ----------------------------------------
	_renderToggleMode() {

		// triggers only reflect active state
		this.allTriggers.forEach(item => {
			const id = item.getAttribute(this.options.dataAttr);

			item.classList.toggle(
				this.options.activeClass,
				this.activeIds.has(id)
			);
		});

		// targets only hide/show their own group independently
		this.allTargets.forEach(item => {
			const id = item.getAttribute(this.options.dataAttr);

			// each target toggles only based on its own ID state
			item.classList.toggle(
				this.options.hideClass,
				this.activeIds.has(id)
			);
		});
	}

	reset() {

		this.activeIds.clear();

		const all = [...this.allTriggers, ...this.allTargets];

		all.forEach(el => {
			el.classList.remove(this.options.hideClass);
			el.classList.remove(this.options.activeClass);
		});
	}
}